import React, {useRef} from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';
import {VideoSlideFilterButtonBox} from "./video-slide-filter-button.box";
import {VideoSlideFilterButtonIconBox} from "./video-slide-filter-button-icon.box";
import {ISvgIconProps} from "../../../../../../basic-ui-components/icon/svg-icon/svg.icon";
import {Check} from "@sparkware/app-utils";
import {IVideoSlidesFilterViewModel} from '../../../../../../services/video-slides/models/video-slides-filter-editor/video-slides-filter-view-model.interface';

interface VideoSlidesHeaderFilterButtonComponentProps {
    videoSlidesFilterEditor: IVideoSlidesFilterViewModel;
    textTranslationKey: string;
    isActive?: boolean;
    icon?: React.ComponentType<ISvgIconProps>;

}

export const VideoSlidesHeaderFilterButtonComponent: React.FC<VideoSlidesHeaderFilterButtonComponentProps> = observer((props) => {
    const services = useServices();
    let filterButtonRef = useRef(null);

    React.useEffect(() => {
        if (filterButtonRef.current && props.videoSlidesFilterEditor.on) {
            setTimeout(() => {
                filterButtonRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'center'
                });
                
            }, 300);
        }
    }, [props.videoSlidesFilterEditor.on]);

    const renderIcon = () => {
        if (Check.isEmpty(props.icon)) {
            return null;
        }

        let Icon = props.icon;
        let iconStyle: React.CSSProperties = props.videoSlidesFilterEditor.on ? {color: services.theme.currentTheme.colors.brandPrimary} : {};
        return (
            <VideoSlideFilterButtonIconBox>
                <Icon size={2} style={iconStyle} />
            </VideoSlideFilterButtonIconBox>
        );
    };

    const getClassName = () => `cy-videos-slides-filter-${props.videoSlidesFilterEditor.on ? 'active' : 'disabled'}`;

    const onClickHandler = async () => {
        await props.videoSlidesFilterEditor.applyFilter();
    }

    return (
        <FlexGrowItemBox ref={filterButtonRef}>
            <VideoSlideFilterButtonBox
                className={getClassName()}
                isActive={props.videoSlidesFilterEditor.on}
                onClick={onClickHandler}                
            >
                {renderIcon()}
                {services.translation.translate(props.textTranslationKey)}
            </VideoSlideFilterButtonBox>
        </FlexGrowItemBox>
    );
})